export default __webpack_public_path__ + "static/media/our-story-sm.929b2701.jpg";